import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Capacitor } from '@capacitor/core';
import { register } from 'swiper/element/bundle';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

register();

// El chat de HubSpot (lo carga GTM) no se carga solo: lo carga HubspotService.openChat() ya con el usuario identificado
window.hsConversationsSettings = { loadImmediately: false };

// GTM también se carga en las apps nativas. La plataforma (mismos valores que mandamos a PostHog) va antes que gtm.js
// para que las etiquetas puedan separar web de app desde el primer evento
(<any>window).dataLayer = (<any>window).dataLayer || [];
(<any>window).dataLayer.push({ app_platform: Capacitor.getPlatform() === 'web' ? 'app-web' : Capacitor.getPlatform() });

// En las apps no hay banner de cookies: todo empieza denegado y DataLayerService.updateNativeConsent() lo actualiza en
// cuanto sabe la respuesta a ATT. wait_for_update hace que las etiquetas esperen a esa actualización
if (Capacitor.isNativePlatform()) {
  // GTM solo reconoce los comandos de gtag si llegan como el objeto arguments, no como un array
  const gtag = function(..._args: any[]) { (<any>window).dataLayer.push(arguments); };
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    wait_for_update: 2000
  });
}

if (environment.enableTagManager) {
  const script1 = document.createElement('script');
  script1.innerHTML = `(function (w, d, s, l, i) {
      w[l] = w[l] || []; w[l].push({
        'gtm.start':
          new Date().getTime(), event: 'gtm.js'
      }); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-KKTNJ57');`;
  document.head.appendChild(script1);
} else {
  const script1 = document.createElement('script');
  script1.innerHTML = `(function (w, d, s, l, i) {
      w[l] = w[l] || []; w[l].push({
        'gtm.start':
          new Date().getTime(), event: 'gtm.js'
      }); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-MZHLMD5');`;
  document.head.appendChild(script1);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
